const generalActionTypes = {
  SET_TEST_GENERAL: 'SET_TEST_GENERAL',
};

export default generalActionTypes;
